// creates a result set id that will point to state

export function createResultSetEntryId(
  projectId: string,
  proposalId: string | undefined,
  queryId: string,
  dataNodeId?: string,
  dynamicId?: string
) {
  const dataNodeIdEntry = dataNodeId === undefined ? '0' : `${dataNodeId}`;
  const dynamicIdEntry = dynamicId === undefined ? '0' : `${dynamicId}`;
  const proposalIdEntry = proposalId === undefined ? 'live' : `${proposalId}`;
  const result = `${projectId}_${proposalIdEntry}_${queryId}_${dataNodeIdEntry}_${dynamicIdEntry}`;

  return result;
}
